const convert_to_api_attributes = (data) => {
    let result = {};
    data.forEach((item) => {
        result[item?.key] = item?.value;
    });
    return result;
};

export default convert_to_api_attributes